import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { alarmsMapConfigProvider } from '../services/alarms-map-config.service';
import { AlarmsListingFiltersSourceService } from './alarms-listing-filters-source.service';
import { AlarmsListingDataSourceService } from './alarms-listing-data-source.service';
import { AlarmsListingExportConfigService } from './alarms-listing-export-config.service';
import { AlarmsListingModelService } from './alarms-listing-model.service';

export const provideAlarmsListing = (): (Provider | EnvironmentProviders)[] => [
  AlarmsListingFiltersSourceService,
  AlarmsListingDataSourceService,
  AlarmsListingExportConfigService,
  { provide: LISTING_MODEL, useClass: AlarmsListingModelService },
  ListingPageService,
  QueryParamsHandlerService,
  alarmsMapConfigProvider
];
